"use strict";import{Tags as e}from"./src/Tags.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-tags",e);
//# sourceMappingURL=sp-tags.js.map
